import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const CheckboxAnswer = ({ question, item, setSelectedAnswer }) => {
  const { t } = useTranslation();

  return <button
    onClick={() => setSelectedAnswer(question, item)}
    className={styles.answer + ' ' + (question.multiple ? (-1 !==  question.answer.indexOf(item) ? styles.selected : styles.unselected) : (question.answer ? question.answer?.key === item.key ? styles.selected : styles.unselected : ''))}
  >
    <span className={styles.checkbox}></span>
    <span className={styles.text}>
      {t(item.text)}
    </span>
  </button>;
}

export default CheckboxAnswer;
